import { Controller } from "@hotwired/stimulus"

// Single-input searchable select: shows current selection in the visible input,
// stores the actual form value in a hidden input, and renders options in a
// dropdown filtered as the user types. Selecting an option (click or Enter)
// submits the parent form when `submitOnSelect` is true.
export default class extends Controller {
  static targets = ["input", "hidden", "panel", "option", "empty"]
  static values  = { submitOnSelect: { type: Boolean, default: false } }

  connect() {
    this.outsideClickHandler = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.refreshOptions("")
    this.inputTarget.select()
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.restoreSelectedLabel()
  }

  filter(event) {
    this.panelTarget.classList.remove("hidden")
    this.refreshOptions(event.target.value)
  }

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    this.hiddenTarget.value = option.dataset.value
    this.inputTarget.value  = (option.dataset.label || option.textContent).trim()
    this.panelTarget.classList.add("hidden")

    if (this.submitOnSelectValue) {
      const form = this.element.closest("form")
      if (form) {
        form.requestSubmit ? form.requestSubmit() : form.submit()
      }
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
      this.inputTarget.blur()
      return
    }
    if (event.key === "Enter") {
      event.preventDefault()
      const first = this.optionTargets.find(o => !o.classList.contains("hidden"))
      if (first) first.click()
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  refreshOptions(query) {
    const search = query.toLowerCase().trim()
    let visible = 0

    this.optionTargets.forEach(option => {
      const label = (option.dataset.label || option.textContent).toLowerCase()
      const match = !search || label.includes(search)
      option.classList.toggle("hidden", !match)
      if (match) visible++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }
  }

  restoreSelectedLabel() {
    const current = this.optionTargets.find(o => o.dataset.value === this.hiddenTarget.value)
    if (current) {
      this.inputTarget.value = (current.dataset.label || current.textContent).trim()
    }
  }
}
